<div class="component-viewer">
  <h1>Create Golf Outing</h1>
  <mat-card>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    <mat-stepper #stepper>
      <mat-step [stepControl]="outingForm" errorMessage="Name is required">
        <div class="row pt-2">
          <div class="col-6">
            <form [formGroup]="outingForm">
              <ng-template matStepLabel>Name</ng-template>
              <mat-form-field>
                <mat-label>Outing Name</mat-label>
                <input matInput formControlName="name" required>
              </mat-form-field>
              <div class="row">
                <div class="col">
                  <button mat-raised-button matStepperNext>Next</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </mat-step>
      <mat-step [stepControl]="outingIterationForm" state="chat">
        <div class="row pt-2">
          <form [formGroup]="outingIterationForm">
            <ng-template matStepLabel>Iteration</ng-template>
            <div class="row">
              <div class="col-3">
                <mat-form-field class="w-100">
                  <mat-label>Start Date</mat-label>
                  <input required matInput [matDatepicker]="startPicker" formControlName="startDateOnly" />
                  <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                  <mat-error *ngIf="outingIterationForm.get('startDateOnly').errors?.required">Start Date is required
                  </mat-error>
                  <mat-error *ngIf="outingIterationForm.get('startDateOnly').errors?.validationErrors">
                    {{ outingIterationForm.get("startDateOnly").errors?.validationErrors}}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-3">
                <mat-form-field class="w-100">
                  <mat-label>Start Time</mat-label>
                  <input required matInput [matTimepicker]="startTimePicker" formControlName="startTimeOnly" />
                  <mat-timepicker #startTimePicker />
                  <mat-timepicker-toggle [for]="startTimePicker" matSuffix />
                  <mat-error *ngIf="outingIterationForm.get('startTimeOnly').errors?.required">Start Time is required
                  </mat-error>
                  <mat-error *ngIf="outingIterationForm.get('startTimeOnly').errors?.validationErrors">
                    {{ outingIterationForm.get("startTimeOnly").errors?.validationErrors}}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field>
                  <mat-label>Cost</mat-label>
                  <span matPrefix>$ &nbsp;</span>
                  <input matInput name="cost" id="cost" placeholder="Cost" type="number" formControlName="cost" />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <course-select-create (courseEvent)="setCourseId($event)" (isLoadingEvent)="isLoading = $event"></course-select-create>
              </div>
              <div class="col-6">
                <mat-form-field>
                  <mat-label>Registration Code</mat-label>
                  <input matInput name="registrationCode" placeholder="Registration Code"
                    formControlName="registrationCode" />
                  <button matSuffix mat-icon-button aria-label="Refresh" (click)="generateRegistrationCode()">
                    <mat-icon>refresh</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-1">
                <button mat-raised-button matStepperPrevious class="secondary">Back</button>&nbsp;
              </div>
              <div class="col-1">
                <button mat-raised-button matStepperNext class="primary" (click)="setDateTime()">Next</button>
              </div>
            </div>
          </form>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Review & Confirm</ng-template>
        <div class="container-fluid pt-3">
          <div class="row mb-4">
            <div class="col-12">
              <h2 class="mb-3">Review Outing Details</h2>
              <p class="text-muted">Please review the information below before creating your outing.</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <mat-card appearance="outlined" class="h-100">
                <mat-card-content>
                  <div class="d-flex align-items-center py-2">
                    <mat-icon color="primary" class="me-3">event</mat-icon>
                    <div class="flex-grow-1">
                      <div class="text-muted small">Outing Name</div>
                      <div class="h5 mb-0">{{outingForm.get('name').value}}</div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <div class="col-md-6 mb-3">
              <mat-card appearance="outlined" class="h-100">
                <mat-card-content>
                  <div class="d-flex align-items-center py-2">
                    <mat-icon color="primary" class="me-3">schedule</mat-icon>
                    <div class="flex-grow-1">
                      <div class="text-muted small">Start Date & Time</div>
                      <div class="h5 mb-0">{{outingIterationForm.get('startDate').value | date: 'EEEE, MMMM d, y'}}</div>
                      <div class="text-muted">{{outingIterationForm.get('startDate').value | date: 'h:mm a'}}</div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <div class="col-md-4 mb-3">
              <mat-card appearance="outlined" class="h-100">
                <mat-card-content>
                  <div class="d-flex align-items-center py-2">
                    <mat-icon color="primary" class="me-3">attach_money</mat-icon>
                    <div class="flex-grow-1">
                      <div class="text-muted small">Cost per Player</div>
                      <div class="h5 mb-0">${{outingIterationForm.get('cost').value | number:'1.2-2'}}</div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <div class="col-md-4 mb-3">
              <mat-card appearance="outlined" class="h-100">
                <mat-card-content>
                  <div class="d-flex align-items-center py-2">
                    <mat-icon color="primary" class="me-3">golf_course</mat-icon>
                    <div class="flex-grow-1">
                      <div class="text-muted small">Golf Course</div>
                      <div class="h5 mb-0">{{outingIterationForm.get('course').value?.name || 'Not selected'}}</div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <div class="col-md-4 mb-3" *ngIf="outingIterationForm.get('registrationCode').value">
              <mat-card appearance="outlined">
                <mat-card-content>
                  <div class="d-flex align-items-center py-2">
                    <mat-icon color="primary" class="me-3">qr_code</mat-icon>
                    <div class="flex-grow-1">
                      <div class="text-muted small">Registration Code</div>
                      <div class="h5 mb-0">{{outingIterationForm.get('registrationCode').value}}</div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>

          <mat-divider class="my-4"></mat-divider>

          <div class="row mb-3">
            <div class="col">
              <button mat-raised-button matStepperPrevious class="secondary">
                <mat-icon>arrow_back</mat-icon>
                Back
              </button>
            </div>
            <div class="col text-end">
              <button mat-raised-button color="warn" (click)="stepper.reset()" class="warning me-2">
                <mat-icon>refresh</mat-icon>
                Reset
              </button>
              <button mat-raised-button color="primary" (click)="onSave()"
                [disabled]="outingForm.invalid || outingIterationForm.invalid">
                <mat-icon>save</mat-icon>
                Create Outing
              </button>
            </div>
          </div>
        </div>
      </mat-step>
    </mat-stepper>
  </mat-card>
</div>